import "./supportcard.scss";
import Button from "../../core/button/button";

const SupportCard = () => {
    return (
        <div className="container">
            <div className="Support-Card mx-3">
                <div className="row">
                    <div className="col-lg-5 col-md-4 col-sm-4 col-12 mb-3 text-center">
                        <img src={require("../../assets/images/photos/Support.png")} alt="support"
                             className="img-fluid Support-Image"/>
                    </div>
                    <div className="col-lg-7 col-md-8 col-sm-8 col-12 mb-3">
                        <div className="Support-Text">
                            <>
                                <h6>نیاز به راهنمایی دارید؟</h6>
                                <p>برای راهنمایی رایگان با شماره 02177889907 تماس بگیرید.</p>
                            </>
                            <Button type={"secondary"} action={() => {
                            }} responsive={false}>چت با پشتیبانی</Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SupportCard;